import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
    { to: "/", label: "Home", testid: "nav-home" },
    { to: "/about", label: "About", testid: "nav-about" },
    { to: "/services", label: "Services", testid: "nav-services" },
    { to: "/industries", label: "Industries", testid: "nav-industries" },
    { to: "/opis", label: "OPIS™", testid: "nav-opis" },
    { to: "/insights", label: "Insights", testid: "nav-insights" },
    { to: "/case-studies", label: "Case Studies", testid: "nav-case-studies" },
    { to: "/contact", label: "Contact", testid: "nav-contact" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const isHome = location.pathname === "/";

    return (
        <header
            data-testid="site-navbar"
            className={`sticky top-0 z-50 w-full border-b border-brand-border ${
                isHome ? "bg-brand-stone/85" : "bg-brand-stone/95"
            } backdrop-blur-md`}
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-12 py-5 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="navbar-logo"
                    className="flex items-center gap-3 group"
                    onClick={() => setOpen(false)}
                >
                    <img
                        src="/logo.png"
                        alt="Optimum Hospitality Solutions"
                        className="h-12 w-12 object-contain"
                        width="48"
                        height="48"
                    />
                    <div className="hidden sm:flex flex-col leading-tight">
                        <span className="font-display text-lg tracking-tight text-brand-navy">
                            Optimum
                        </span>
                        <span className="text-[10px] uppercase tracking-[0.25em] text-brand-champagne font-medium">
                            Hospitality Solutions
                        </span>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-7">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={item.testid}
                            end={item.to === "/"}
                            className={({ isActive }) =>
                                `text-sm tracking-wide link-underline transition-colors ${
                                    isActive
                                        ? "text-brand-navy font-medium"
                                        : "text-brand-ink/70 hover:text-brand-navy"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/booking"
                        data-testid="navbar-cta"
                        className="ml-1 inline-flex items-center px-5 py-2.5 bg-brand-navy text-brand-stone text-sm tracking-wide hover:bg-brand-hover transition-colors"
                    >
                        Book a Consultation
                    </Link>
                </nav>

                <button
                    data-testid="navbar-mobile-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="lg:hidden text-brand-navy"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="navbar-mobile-menu"
                    className="lg:hidden border-t border-brand-border bg-brand-stone px-6 py-6 space-y-4"
                >
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={`mobile-${item.testid}`}
                            end={item.to === "/"}
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                                `block text-base ${
                                    isActive
                                        ? "text-brand-navy font-medium"
                                        : "text-brand-ink/80"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                    <Link
                        to="/booking"
                        data-testid="mobile-navbar-cta"
                        onClick={() => setOpen(false)}
                        className="inline-flex items-center px-5 py-2.5 bg-brand-navy text-brand-stone text-sm tracking-wide"
                    >
                        Book a Consultation
                    </Link>
                </div>
            )}
        </header>
    );
};
